import { render, staticRenderFns } from "./semiThirdAnswer.vue?vue&type=template&id=07790dd3&scoped=true"
import script from "./semiThirdAnswer.vue?vue&type=script&lang=js"
export * from "./semiThirdAnswer.vue?vue&type=script&lang=js"
import style0 from "./semiThirdAnswer.vue?vue&type=style&index=0&id=07790dd3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07790dd3",
  null
  
)

export default component.exports